module.exports = __webpack_public_path__ + "static/media/create-private-app.f70af6ce.svg";